module.exports = __webpack_public_path__ + "img/hardware2.765cecc8.png";